<template>
  <v-input v-model="value" :rules="rules" :disabled="disabled" :error-messages="errorMessages">
    <v-sheet outlined rounded class="outlined-block" :class="{'dark-border':darkMode,'disabled-border':disabled}" :min-height="minHeight" :height="height" width="100%">
      <div class="outlined-block-title" :class="{'grey--text':disabled,'dark-title':darkMode}">{{title}}</div>
      <slot/>
    </v-sheet>
  </v-input>
</template>

<style scoped>
.outlined-block {
  position:relative;
  border-color:#9e9e9e;
}
.dark-border {
  border-color:#545454;
}
.disabled-border {
  border-color:#00000031;
}
.outlined-block-title {
  font-size:16px;
  transform-origin: 0px 0px;
  transform: scale(0.85);
  color:#6c6c6c;
  display:inline-block;
  position:absolute;
  top:-10px;
  left: 8px;
  padding-left:4px;
  padding-right:4px;
  background-color:#fff;
}
.dark-title {
  color:#bcbcbc;
  background-color:#1e1e1e;
}
</style>

<script>
export default {
  name: 'OutlinedBlock',
  props: {
    value: {required:false},
    title: {type:String, required:false},
    minHeight: {type:[String,Number], required:false,default:20},
    height: {type:[String,Number], required:false},
    disabled: {type:Boolean, required:false, default:false},
    rules: {type:Array, required:false},
    errorMessages: {type:String, required:false}
  }
}
</script>